import { render, staticRenderFns } from "./CustomFileList.vue?vue&type=template&id=04c354c4&scoped=true&"
import script from "./CustomFileList.vue?vue&type=script&lang=js&"
export * from "./CustomFileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c354c4",
  null
  
)

export default component.exports